import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { addScrollClickTrigger, init as initHashScrolling } from '@project/shared/utils/hashscrolling/js/hashscrolling';

const classes = {
	button: 'js-m-stage-content__button'
};

@createModule('StageContent')
/**
 * Stage Content module implementation.
 */
export class StageContent extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		if(this.$ctx.find(`.${classes.button}`).length > 0) {
			this.handleCtaButtonClick();
		}

		resolve();
	}

	private handleCtaButtonClick(): void {
		const button = this.$ctx.find(`.${classes.button}`);
		const url = button.attr('href');
		const idx = url.indexOf('#');

		if (idx === -1) {
			// The link does not contain a hash.
			return;
		}

		const target = $(url.substring(idx));
		if (target.length === 1) {
			this.applyScrollToHandler(button);
		}
	}

	private applyScrollToHandler(button: JQuery<HTMLElement>): void {
		initHashScrolling();
		addScrollClickTrigger(button);
	}

	stop() {}
}
